import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../../../../../utils/HelpdeskCommon.class';
import { MessagesStore } from '../../../../../../../../utils/Stores/messages-store';
import { Store } from '../../../../../../../../utils/Stores/store';

@Component({
  tag: 'chat-message-menu-component',
  styleUrl: 'chat-message-menu-module.scss',
  shadow: true,
})
export class ModuleChatMessageMenu {
  private project = window['CURRENT_PROJECT'];

  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly lastMessage: { total: number; index: number };

  @Event() selectValue: EventEmitter<{ value: string; type: string }>;
  @Event() openSupportModuleFaq: EventEmitter<number>;
  @Event() closeEvent: EventEmitter;

  @State() loadingReset = false;

  private submit(item: IWCChatMessageValue, type = 'text') {
    if (item.type === 'connection') {
      window.location.href =
        wcShared?.store?.productsRouting?.shop + '/auth/login?project=' + this.project;
    } else if (item.type === 'faq') {
      this.openSupportModuleFaq.emit(item.value);
    } else if (item.type === 'technical_question_menu_reply') {
      this.selectValue.emit({ value: item.value, type: 'technical_question_menu_reply' });
    } else if (item.type === 'close') {
      this.closeEvent.emit();
      this.resetConversation();
    } else {
      this.selectValue.emit({ value: item.value, type });
    }
  }

  private resetConversation() {
    if (this.loadingReset) {
      return;
    }

    this.loadingReset = true;

    let url = `/api/components/chatbot/reset?lang=${wcShared?.store?.getLang()}`;
    url += helpdeskCommon.urlFormatFaq();

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          return r.json().then((response) => {
            Store?.set('bot_id', response.data.bot_id);
            Store?.set('channel_id', response.data.channel_id);
            Store?.set('routing', []);
            this.loadingReset = false;

            MessagesStore?.set('messages', response?.data?.messages);
          });
        }
      })
      .catch((err) => {
        this.loadingReset = false;
        console.error(err);
      });
  }

  render() {
    return (
      <Host>
        <div
          class="menu-title"
          innerHTML={this.message?.title}
        ></div>
        <div
          class={{ 'menu-action': true, 'menu-action--vertical': this.message?.action?.length > 2 }}
          data-e2e="wc-helpdesk-welcome-choice"
        >
          {(this.message?.action as IWCChatMessageValue[])?.map((item) => {
            return (
              <button
                type="button"
                onClick={() => this.submit(item)}
                disabled={this.lastMessage?.total !== this.lastMessage?.index}
              >
                {item?.label}
              </button>
            );
          })}
        </div>
      </Host>
    );
  }
}
